import {
  dynamicRenderClassToElement,
  whenElementExists,
} from '$shared/utils.js';
import { publicCustomElementModules } from './manifest.ts';
import { loadCustomElements } from './custom_element_loader.ts';

// Eagerly loaded custom elements
import './parsely_conversion_component.ts';
import './ga4_purchase_component.ts';

loadCustomElements(publicCustomElementModules);

// JavaScript
whenElementExists(
  '[data-impact-item-id]',
  () => import('./impact/featured_items_component.js')
);
whenElementExists(
  '[data-sidebar-v1],[data-sidebar-germany]',
  () => import('./series_sidebar_component.js')
);
dynamicRenderClassToElement(
  '.tmp-photo-slideshow-endrun',
  () => import('./photo_slideshow_component.js'),
  { skipRender: true }
);
whenElementExists('.dropdown', () => import('./dropdown_menu_component.js'));

// only include lite-youtube when it's on the page
whenElementExists(
  'lite-youtube',
  () => import('./video_iframe_embed_component.js')
);
